import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import {
  SILENT_SSO_FALLBACK_ERRORS,
  consumeSilentAttempt,
  markForceInteractive,
  refreshViaAuthService
} from "../_redux/authCrud";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

function Callback(props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fallbackStartedRef = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const authError = params.get("auth_error");

    if (authError) {
      const wasSilent = consumeSilentAttempt();
      if (
        wasSilent &&
        SILENT_SSO_FALLBACK_ERRORS.includes(authError) &&
        !fallbackStartedRef.current
      ) {
        fallbackStartedRef.current = true;
        markForceInteractive();
        // prompt=login survives React remounts; avoids silent↔callback loop.
        window.location.replace("/auth/login?prompt=login");
        return;
      }
      const description = params.get("error_description");
      setError(
        description ? `OAuth: ${authError} — ${description}` : `OAuth: ${authError}`
      );
      setLoading(false);
      return;
    }

    if (params.get("auth") !== "ok") {
      consumeSilentAttempt();
      props.logout();
      window.location.replace("/auth/login");
      return;
    }

    consumeSilentAttempt();

    (async () => {
      try {
        const data = await refreshViaAuthService();
        if (!data?.access_token) {
          throw new Error("resposta sem access_token");
        }

        const expiresIn = Number(data.expires_in);
        const hasValidExpiresIn = Number.isFinite(expiresIn) && expiresIn > 0;

        props.login(
          data.access_token,
          undefined,
          hasValidExpiresIn ? expiresIn : undefined,
          data.id_token || undefined
        );
      } catch (err) {
        console.error("[auth] callback: falha ao obter tokens via auth-service", err);
        setError("Resposta de autenticacao invalida.");
        setLoading(false);
      }
    })();
  }, [props.login, props.logout]);

  if (loading) {
    return <LayoutSplashScreen />;
  }

  if (!error) {
    return null;
  }

  return (
    <div
      className="jusfy-login"
      style={{
        background: `url(${toAbsoluteUrl(
          "/media/bg/bg-login.png"
        )}) no-repeat center center fixed`
      }}
    >
      <div className="head-login">
        <div className="container">
          <div className="logo">
            <img src={toAbsoluteUrl("/media/logos/logo-light.svg")} alt="Jusfy" />
          </div>
        </div>
      </div>
      <div
        className="content-login d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "60vh", paddingTop: "2rem" }}
      >
        <div
          className="box-login"
          style={{
            border: "1px solid var(--border-neutral-subtle)",
            padding: "30px",
            borderRadius: "10px",
            maxWidth: "480px",
            width: "100%",
            background: "var(--bg-neutral-layer01)"
          }}
        >
          <div className="mb-8 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{error}</div>
          </div>
          <Link to="/auth/login" className="btn btn-primary">
            Voltar ao login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Callback));
